let flyOptions = {
  "duration":   500,
  "delay":      0,
  "direction":  "top"
};



$w.onReady(function () {
	//TODO: write your page related code here...

});



export function box2_viewportEnter(event) {
$w("#section1").scrollTo();
$w("#vectorImage").show("fly",flyOptions);
}




export function gallery1_viewportEnter(event) {
	$w("#section9").scrollTo();
	$w("#vectorImage").hide("fly",flyOptions);
}
